// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"e36539b2","361":"4f91f14f","673":"63906c91"}[chunkId] + ".chunk.js";
};